"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.94034 3.12125L2.02269 15.7458C1.92383 15.9278 1.87428 16.1324 1.87897 16.3395C1.88365 16.5465 1.94241 16.7487 2.0494 16.926C2.15639 17.1033 2.3079 17.2496 2.48888 17.3502C2.66987 17.4509 2.87403 17.5024 3.0811 17.4998H16.9206C17.1274 17.5016 17.331 17.4495 17.5115 17.3487C17.692 17.2478 17.8432 17.1016 17.95 16.9246C18.0568 16.7476 18.1157 16.5458 18.1208 16.339C18.1259 16.1323 18.077 15.9279 17.979 15.7458L11.0576 3.12125C10.9524 2.93287 10.7988 2.77599 10.6127 2.66678C10.4266 2.55757 10.2148 2.5 9.99898 2.5C9.78321 2.5 9.57135 2.55757 9.38525 2.66678C9.19915 2.77599 9.04557 2.93287 8.94034 3.12125ZM10.3002 8.3594C10.5116 8.3594 10.6812 8.53411 10.675 8.74546L10.5565 12.7611C10.5505 12.9638 10.3845 13.1251 10.1817 13.1251H9.81629C9.6135 13.1251 9.44744 12.9638 9.44146 12.7611L9.32297 8.74546C9.31673 8.53411 9.48637 8.3594 9.6978 8.3594H10.3002ZM9.99875 15.7186C9.8578 15.7133 9.72152 15.6666 9.6069 15.5844C9.49227 15.5022 9.40436 15.3881 9.35409 15.2563C9.30383 15.1245 9.29344 14.9808 9.32422 14.8432C9.35499 14.7055 9.42558 14.58 9.52718 14.4821C9.62879 14.3843 9.75693 14.3185 9.89564 14.2929C10.0344 14.2674 10.1775 14.2832 10.3073 14.3384C10.4371 14.3936 10.5478 14.4857 10.6257 14.6034C10.7035 14.721 10.745 14.859 10.745 15C10.7441 15.0965 10.724 15.1918 10.6858 15.2804C10.6476 15.369 10.5922 15.4491 10.5227 15.516C10.4532 15.5829 10.3711 15.6353 10.2811 15.67C10.1912 15.7048 10.0952 15.7213 9.99875 15.7186Z",
    fill: fill
  }));
};

exports["default"] = _default;